import { FIELDS } from './constants';

const defaultFields = [
  // {
  //   field: 'commands',
  //   title: ' ',
  //   cell: 'commands',
  //   headerCell: 'commandsHeader',
  //   sortable: false,
  //   hidden: false,
  //   locked: true,
  //   width: 40,
  // },
  // {
  //   field: 'selectcommands',
  //   title: ' ',
  //   cell: 'selectcommands',
  //   headerCell: 'selectCommandsHeader',
  //   sortable: true,
  //   hidden: false,
  //   locked: true,
  //   width: 30,
  // },

  {
    key: 'Id',
    field: FIELDS.ID,
    title: ' Id',
    label: 'Id',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ServiceOrderLineId',
    field: FIELDS.SERVICE_ORDER_LINE_ID,
    title: ' Work Order Line Id',
    label: 'ServiceOrderLineId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ServiceItemTypeId',
    field: FIELDS.SERVICE_ITEM_TYPE_ID,
    title: ' Service Item Type Id',
    label: 'ServiceItemTypeId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'ServiceTypeName',
    field: FIELDS.SERVICE_TYPE_NAME,
    title: ' Service Type Name',
    label: 'ServiceTypeName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Quantity',
    field: FIELDS.QUANTITY,
    title: ' Quantity',
    label: 'Quantity',
    cell: 'formatSeparator',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Cost',
    field: FIELDS.COST,
    title: ' Cost',
    label: 'Cost',
    cell: 'formatCurrency',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Total',
    field: FIELDS.TOTAL,
    title: ' Total',
    label: 'Total',
    cell: 'formatCurrency',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'StatusName',
    field: FIELDS.STATUS_NAME,
    title: ' Status',
    label: 'Status',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Comments',
    field: FIELDS.COMMENT,
    title: ' Comments',
    label: 'Comments',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'CreatedByUserId',
    field: FIELDS.CREATED_BY_USER_ID,
    title: ' Created By User Id',
    label: 'CreatedByUserId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'CreatedByUserFullName',
    field: FIELDS.CREATED_BY_USER_FULL_NAME,
    title: ' Created By User Full Name',
    label: 'CreatedByUserFullName',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'ModifiedByUserId',
    field: FIELDS.MODIFIED_BY_USER_ID,
    title: ' Modified By User Id',
    label: 'ModifiedByUserId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'ModifiedByUserFullName',
    field: FIELDS.MODIFIED_BY_USER_FULL_NAME,
    title: ' Modified By User Full Name',
    label: 'ModifiedByUserFullName',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'DateCreated',
    field: FIELDS.DATE_CREATED,
    title: ' Date Created',
    label: 'DateCreated',
    cell: 'formatDate',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'DateModified',
    field: FIELDS.DATE_MODIFIED,
    title: ' Date Modified',
    label: 'DateModified',
    cell: 'formatDate',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'Active',
    field: FIELDS.ACTIVE,
    title: ' Active',
    label: 'Active',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    field: 'deletecommands',
    title: ' ',
    cell: 'deletecommands',
    headerCell: 'commandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
]

export default defaultFields;
